import { PlatformTestObjectOverridesSource } from "../@types"

export interface PlatformTestObjectOverrides {
  testObjectSize: number
  targetFrequency: number | undefined
}

export const createPlatformTestObjectOverrides: (
  source: PlatformTestObjectOverridesSource,
) => PlatformTestObjectOverrides = (s) => new PlatformTestObjectOverridesImpl(s)

class PlatformTestObjectOverridesImpl implements PlatformTestObjectOverrides {
  private _testObjectSize
  private _targetFrequency
  constructor(source: PlatformTestObjectOverridesSource) {
    /* eslint-disable @typescript-eslint/dot-notation */
    this._testObjectSize = source["size"]
    this._targetFrequency = source["target_frequency"]
    /* eslint-enable @typescript-eslint/dot-notation */
  }
  get testObjectSize() {
    return this._testObjectSize
  }
  get targetFrequency() {
    return this._targetFrequency
  }
}
